"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["inline", "columns", "rows", "areas", "template", "gap", "gridGap", "columnGap", "rowGap", "justifyItemsStart", "justifyItemsEnd", "justifyItemsCenter", "justifyItemsStretch", "justifyItems", "alignItemsStart", "alignItemsEnd", "alignItemsCenter", "alignItemsStretch", "alignItems", "placeItems", "justifyContentStart", "justifyContentEnd", "justifyContentCenter", "justifyContentStretch", "justifyContentSpaceAround", "justifyContentSpaceBetween", "justifyContentSpaceEvenly", "justifyContent", "alignContentStart", "alignContentEnd", "alignContentCenter", "alignContentStretch", "alignContentSpaceAround", "alignContentSpaceBetween", "alignContentSpaceEvenly", "alignContent", "placeContent", "autoFlowRow", "autoFlowColumn", "autoFlowDense", "autoFlow", "autoRows", "autoColumns", "style", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var overlapping_1 = require("../helpers/overlapping");

var trim_1 = require("../helpers/trim");

function GridContainer(_ref) {
  var inline = _ref.inline,
      columns = _ref.columns,
      rows = _ref.rows,
      areas = _ref.areas,
      template = _ref.template,
      gap = _ref.gap,
      gridGap = _ref.gridGap,
      columnGap = _ref.columnGap,
      rowGap = _ref.rowGap,
      justifyItemsStart = _ref.justifyItemsStart,
      justifyItemsEnd = _ref.justifyItemsEnd,
      justifyItemsCenter = _ref.justifyItemsCenter,
      justifyItemsStretch = _ref.justifyItemsStretch,
      justifyItems = _ref.justifyItems,
      alignItemsStart = _ref.alignItemsStart,
      alignItemsEnd = _ref.alignItemsEnd,
      alignItemsCenter = _ref.alignItemsCenter,
      alignItemsStretch = _ref.alignItemsStretch,
      alignItems = _ref.alignItems,
      placeItems = _ref.placeItems,
      justifyContentStart = _ref.justifyContentStart,
      justifyContentEnd = _ref.justifyContentEnd,
      justifyContentCenter = _ref.justifyContentCenter,
      justifyContentStretch = _ref.justifyContentStretch,
      justifyContentSpaceAround = _ref.justifyContentSpaceAround,
      justifyContentSpaceBetween = _ref.justifyContentSpaceBetween,
      justifyContentSpaceEvenly = _ref.justifyContentSpaceEvenly,
      justifyContent = _ref.justifyContent,
      alignContentStart = _ref.alignContentStart,
      alignContentEnd = _ref.alignContentEnd,
      alignContentCenter = _ref.alignContentCenter,
      alignContentStretch = _ref.alignContentStretch,
      alignContentSpaceAround = _ref.alignContentSpaceAround,
      alignContentSpaceBetween = _ref.alignContentSpaceBetween,
      alignContentSpaceEvenly = _ref.alignContentSpaceEvenly,
      alignContent = _ref.alignContent,
      placeContent = _ref.placeContent,
      autoFlowRow = _ref.autoFlowRow,
      autoFlowColumn = _ref.autoFlowColumn,
      autoFlowDense = _ref.autoFlowDense,
      autoFlow = _ref.autoFlow,
      autoRows = _ref.autoRows,
      autoColumns = _ref.autoColumns,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var displayStyle = react_1.default.useMemo(function () {
    return {
      display: inline ? 'inline-grid' : 'grid'
    };
  }, [inline]);
  var gridTemplateColumnsStyle = react_1.default.useMemo(function () {
    return {
      gridTemplateColumns: columns
    };
  }, [columns]);
  var gridTemplateRowsStyle = react_1.default.useMemo(function () {
    return {
      gridTemplateRows: rows
    };
  }, [rows]);
  var gridTemplateAreasStyle = react_1.default.useMemo(function () {
    return {
      gridTemplateAreas: areas
    };
  }, [areas]);
  var gridTemplateStyle = react_1.default.useMemo(function () {
    return {
      gridTemplate: template
    };
  }, [template]);
  var gridGapStyle = react_1.default.useMemo(function () {
    return {
      gap: gap || gridGap,
      gridGap: gap || gridGap
    };
  }, [gap, gridGap]);
  var gridColumnGapStyle = react_1.default.useMemo(function () {
    return {
      columnGap: columnGap,
      gridColumnGap: columnGap
    };
  }, [columnGap]);
  var gridRowGapStyle = react_1.default.useMemo(function () {
    return {
      rowGap: rowGap,
      gridRowGap: rowGap
    };
  }, [rowGap]);
  var justifyItemsStyle = react_1.default.useMemo(function () {
    if (justifyItems) return {
      justifyItems: justifyItems
    };
    (0, overlapping_1.checkOverlapping)('justify-items', justifyItemsStart, justifyItemsEnd, justifyItemsCenter, justifyItemsStretch);
    var value = null;
    if (justifyItemsStart) value = 'start';else if (justifyItemsEnd) value = 'end';else if (justifyItemsCenter) value = 'center';else if (justifyItemsStretch) value = 'stretch';
    return value ? {
      justifyItems: value
    } : {};
  }, [justifyItems, justifyItemsStart, justifyItemsEnd, justifyItemsCenter, justifyItemsStretch]);
  var alignItemsStyle = react_1.default.useMemo(function () {
    if (alignItems) return {
      alignItems: alignItems
    };
    (0, overlapping_1.checkOverlapping)('align-items', alignItemsStart, alignItemsEnd, alignItemsCenter, alignItemsStretch);
    var value = null;
    if (alignItemsStart) value = 'start';else if (alignItemsEnd) value = 'end';else if (alignItemsCenter) value = 'center';else if (alignItemsStretch) value = 'stretch';
    return value ? {
      alignItems: value
    } : {};
  }, [alignItems, alignItemsStart, alignItemsEnd, alignItemsCenter, alignItemsStretch]);
  var placeItemsStyle = react_1.default.useMemo(function () {
    return {
      placeItems: placeItems
    };
  }, [placeItems]);
  var justifyContentStyle = react_1.default.useMemo(function () {
    if (justifyContent) return {
      justifyContent: justifyContent
    };
    (0, overlapping_1.checkOverlapping)('justify-content', justifyContentStart, justifyContentEnd, justifyContentCenter, justifyContentStretch, justifyContentSpaceAround, justifyContentSpaceBetween, justifyContentSpaceEvenly);
    var value = null;
    if (justifyContentStart) value = 'start';else if (justifyContentEnd) value = 'end';else if (justifyContentCenter) value = 'center';else if (justifyContentStretch) value = 'stretch';else if (justifyContentSpaceAround) value = 'space-around';else if (justifyContentSpaceBetween) value = 'space-between';else if (justifyContentSpaceEvenly) value = 'space-evenly';
    return value ? {
      justifyContent: value
    } : {};
  }, [justifyContent, justifyContentStart, justifyContentEnd, justifyContentCenter, justifyContentStretch, justifyContentSpaceAround, justifyContentSpaceBetween, justifyContentSpaceEvenly]);
  var alignContentStyle = react_1.default.useMemo(function () {
    if (alignContent) return {
      alignContent: alignContent
    };
    (0, overlapping_1.checkOverlapping)('align-content', alignContentStart, alignContentEnd, alignContentCenter, alignContentStretch, alignContentSpaceAround, alignContentSpaceBetween, alignContentSpaceEvenly);
    var value = null;
    if (alignContentStart) value = 'start';else if (alignContentEnd) value = 'end';else if (alignContentCenter) value = 'center';else if (alignContentStretch) value = 'stretch';else if (alignContentSpaceAround) value = 'space-around';else if (alignContentSpaceBetween) value = 'space-between';else if (alignContentSpaceEvenly) value = 'space-evenly';
    return value ? {
      alignContent: value
    } : {};
  }, [alignContent, alignContentStart, alignContentEnd, alignContentCenter, alignContentStretch, alignContentSpaceAround, alignContentSpaceBetween, alignContentSpaceEvenly]);
  var placeContentStyle = react_1.default.useMemo(function () {
    return {
      placeContent: placeContent
    };
  }, [placeContent]);
  var gridAutoFlowStyle = react_1.default.useMemo(function () {
    if (autoFlow) return {
      gridAutoFlow: autoFlow
    };
    (0, overlapping_1.checkOverlapping)('grid-auto-flow', autoFlowRow, autoFlowColumn, autoFlowDense);
    var value = null;
    if (autoFlowRow) value = 'row';else if (autoFlowColumn) value = 'column';else if (autoFlowDense) value = 'dense';
    return value ? {
      gridAutoFlow: value
    } : {};
  }, [autoFlow, autoFlowRow, autoFlowColumn, autoFlowDense]);
  var gridAutoRowsStyle = react_1.default.useMemo(function () {
    return {
      gridAutoRows: autoRows
    };
  }, [autoRows]);
  var gridAutoColumnsStyle = react_1.default.useMemo(function () {
    return {
      gridAutoColumns: autoColumns
    };
  }, [autoColumns]);
  var combinedStyle = (0, trim_1.trimUndefined)(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, displayStyle), gridTemplateColumnsStyle), gridTemplateRowsStyle), gridTemplateAreasStyle), gridTemplateStyle), gridGapStyle), gridColumnGapStyle), gridRowGapStyle), justifyItemsStyle), alignItemsStyle), placeItemsStyle), justifyContentStyle), alignContentStyle), placeContentStyle), gridAutoFlowStyle), gridAutoRowsStyle), gridAutoColumnsStyle), style));
  return react_1.default.createElement("div", _objectSpread({
    style: combinedStyle
  }, rest), children);
}

exports.default = GridContainer;